module.exports = __webpack_public_path__ + "7d8bd24ef056e85b177fe8f725996905.png";